// Functions
import './functions/widgets';
import './functions/utm-cookies';
import './functions/data-layer';

// Components
import '../../components/header/header';
import '../../components/header/header-pwa';
import '../../components/footer/footer';
import '../../components/calculator/calculator';
import '../../components/accordion/accordion';
import '../../components/promotions/promotions';
import '../../components/modals/modals';
import '../../components/contact-form/contact-form';

// Gutenberg Blocks
import '../../blocks/banner/banner';
import '../../blocks/testimonials/testimonials';
import '../../blocks/testimonials/feedback/feedback';
import '../../blocks/information/information';
import '../../blocks/relinking/relinking';
import '../../blocks/repay/repay';
